import {inject, Injectable} from '@angular/core';
import {ConfirmDialogComponent} from './confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Injectable({
    providedIn: 'root'
})
export class ConfirmDialogService {
    readonly dialog = inject(MatDialog);

    constructor() {
    }

    confirmClose(title: string, text: string) {
        this.dialog.open(ConfirmDialogComponent, {
            panelClass: 'confirm-dialog',
            disableClose: true,
            maxWidth: 'min(500px, calc(100vw - 32px))',
            minWidth: 'min(400px, calc(100vw - 32px))',
            data: {
                title: title,
                text: text,
                confirm: 'Sluiten',
                cancel: null
            }
        });
    }

    confirm(title: string, text: string, confirm = 'Oké', cancel = 'Annuleren', confirmFunction?: Function, width = '500px'): Promise<any> {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            panelClass: 'confirm-dialog',
            width,
            maxWidth: 'calc(100vw - 32px)',
            disableClose: true,
            data: {
                title: title,
                text: text,
                confirm: confirm,
                cancel: cancel,
                confirmFunction: confirmFunction
            }
        });

        return new Promise<void>((resolve, reject) => {
            const subs = dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    resolve();
                } else {
                    reject();
                }
                subs.unsubscribe();
            });
        });
    }
}
